import { INITIALIZE, AUTH_TUTOR } from 'actions'
export default (state = [], action) => {
    if (action.error) return state

    switch (action.type) {
        case AUTH_TUTOR:
        case INITIALIZE:
            return action.payload.tutorMultisites
        default:
            return state
    }
}
